"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropTrailingZero = exports.getGeneralFloatValueGreaterThan10 = exports.getGeneralFloatValueLessThan10 = exports.generalFormatFloat = exports.generalFormat = exports.isGeneral = void 0;
var math_1 = require("../math");
// TODO: 后期修改引用路径, 暂时从原函数中引用
var Common_1 = require("../../utils/Common");
/**
 * 利用字符码判断输入格式串是否是 General
 * @param foramt 输入 format 字符串
 * @param startIndex 判断起始位置
 */
function isGeneral(format, startIndex) {
    if (startIndex === void 0) { startIndex = 0; }
    return (format.length >= 7 + startIndex &&
        (format.charCodeAt(startIndex) | 32) === 103 &&
        (format.charCodeAt(startIndex + 1) | 32) === 101 &&
        (format.charCodeAt(startIndex + 2) | 32) === 110 &&
        (format.charCodeAt(startIndex + 3) | 32) === 101 &&
        (format.charCodeAt(startIndex + 4) | 32) === 114 &&
        (format.charCodeAt(startIndex + 5) | 32) === 97 &&
        (format.charCodeAt(startIndex + 6) | 32) === 108);
}
exports.isGeneral = isGeneral;
/**
 * 常规格式下数值解析
 * @param value 输入值
 */
function generalFormat(value) {
    // 判断输入值是否属于数值类值或字符串且不包含换行符
    if (Common_1.isNumeric(value) && !/\n/.test(String(value))) {
        var numeralValue = Number(value);
        // 无法解析直接返回原值
        if (numeralValue === Infinity || numeralValue === -Infinity) {
            return String(value);
        }
        // 根据是否为整数或是浮点数选择对应的解析方法
        return (numeralValue | 0) === numeralValue ? String(numeralValue) : generalFormatFloat(numeralValue);
    }
    return String(value);
}
exports.generalFormat = generalFormat;
/**
 * 常规格式下数值解析 - 浮点数解析
 * @param value 输入值
 */
function generalFormatFloat(value) {
    // 声明返回结果
    var output;
    // 计算数值幂级, 例如 123.456 为 2; 0.1 为 -1
    var logValueLength = Math.floor(math_1.mathLog10(Math.abs(value)));
    if (logValueLength >= -4 && logValueLength <= -1) {
        // 输入值属于区间 [0.0001, 1) 或者 (-1, -0.0001] 在这个范围内小于 1 的数不会因为位数过长而被转为科学计数
        // 确保小数点前后总数字位数加起来为 10
        output = value.toPrecision(10 + logValueLength);
    }
    else if (Math.abs(logValueLength) <= 9) {
        // 输入值属于区间 [10^-9, 0.0001) U [1, 10^10) 或者 (-0.0001, -10^-9] U (-10^10, -1]
        output = getGeneralFloatValueLessThan10(value);
    }
    else if (logValueLength === 10) {
        // 输入值属于区间 [10^10, 10^11) 或者 (-10^11, 10^10]
        // 此时最大数字位数变为 11 位, 对齐 excel
        // TODO: 此处未考虑进位问题, 后期产品侧进行定夺
        output = value.toFixed(10).substr(0, 12);
    }
    else {
        // 其余情况
        output = getGeneralFloatValueGreaterThan10(value);
    }
    return dropTrailingZero(output);
}
exports.generalFormatFloat = generalFormatFloat;
/**
 * 浮点数解析 - 当计算数值幂次小于 10 时获得最终输出
 * @param value 输入值
 */
function getGeneralFloatValueLessThan10(value) {
    // 判断最终结果字符串应该保留的长度, 最多保留 10 位有效数字; 大于 0 由于包含小数点为 11 位, 小于 0 由于包含负号和小数点因此为 12 位
    var maxWidth = value < 0 ? 12 : 11;
    // 小数点后统一固定精度 12 位再去除多余的尾部 0
    var output = dropTrailingZero(value.toFixed(12));
    // 若满足最大长度限制可提前返回
    if (output.length <= maxWidth) {
        return output;
    }
    // 精度取 10 位
    output = value.toPrecision(10);
    // 存在进位情况如 9999999999.9, 同时在小数情况下 toPrecision 的精度计算是从不为 0 的数开始, 造成位数超出
    if (output.length <= maxWidth) {
        return output;
    }
    // 若仍不满足用科学计数代替
    return value.toExponential(5);
}
exports.getGeneralFloatValueLessThan10 = getGeneralFloatValueLessThan10;
/**
 * 浮点数解析 - 当计算数值幂次大于 10 时获得最终输出
 * @param value 输入值
 */
function getGeneralFloatValueGreaterThan10(value) {
    // 用来匹配数值字符串后多余的 0, 但排除 X.00000 这种情况
    var partialTrailingZeroRegExp = /\.(\d*[1-9])0+$/;
    // 判断最终结果字符串应该保留的长度, 最多保留 10 位有效数字; 大于 0 由于包含小数点为 11 位, 小于 0 由于包含负号和小数点因此为 12 位
    var maxWidth = value < 0 ? 12 : 11;
    // TODO: 源码中这里固定 11 位 暂不清楚原因
    var output = value.toFixed(11).replace(partialTrailingZeroRegExp, '.$1');
    if (output.length > maxWidth) {
        output = value.toPrecision(6);
    }
    return output;
}
exports.getGeneralFloatValueGreaterThan10 = getGeneralFloatValueGreaterThan10;
/**
 * 去除跟在数值字符串后面多余的 0
 * @param value 输入值
 */
function dropTrailingZero(value) {
    // 用来匹配数值字符串后多余的 0, 例如 123.50 会匹配 123.5 和 0; 123.0 匹配 123 和 .0
    var deleteZeroRegExp = /(?:\.0*|(\.\d+?)0+)$/;
    // 数值为科学计数形式需要进行处理
    if (/[Ee]/.test(value)) {
        // 将字符串按照 E 分开
        var splitList = value.split(/[Ee]/);
        var textBeforeE = splitList[0];
        var textAfterE = splitList[1];
        // 分别对 E 前后的字符进行处理
        textBeforeE = /\./.test(textBeforeE) ? textBeforeE.replace(deleteZeroRegExp, '$1') : textBeforeE;
        textAfterE = textAfterE.replace(/([+-])(\d)$/, '$10$2');
        return textBeforeE + "E" + textAfterE;
    }
    // 非科学计数
    return /\./.test(value) ? value.replace(deleteZeroRegExp, '$1') : value;
}
exports.dropTrailingZero = dropTrailingZero;
//# sourceMappingURL=general-format-utils.js.map